import { render, staticRenderFns } from "./ResponsiveDataTable.vue?vue&type=template&id=d0d98bd0&scoped=true&"
import script from "./ResponsiveDataTable.vue?vue&type=script&lang=js&"
export * from "./ResponsiveDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveDataTable.vue?vue&type=style&index=0&id=d0d98bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d98bd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataFooter,VDataTable,VIcon})
